import { cn } from '@/lib/cn';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import {
    formatNationalIdentifierText,
    formatNationalIdentityNumber,
} from '@/caregiverSpace/shared/lib';
import { PropertyType } from '@/caregiverSpace/shared/model';
import { CopyableField } from '@/caregiverSpace/shared/ui';

import { NationalIdentifierView } from '../ui/NationalIdentifierView';

type AddNationalIdentifierFieldPropertyObjectProps = {
    nationalIdentifier?: string;
    birthdate?: string;
    shouldBeCopyable?: boolean;
    isInvalid?: boolean;
    isPending?: boolean;
    shouldBeHidden?: boolean;
    previousNationalIdentifier?: string;
    newNationalIdentifier?: string;
    className?: string;
};
export const addNationalIdentifierFieldPropertyObject = ({
    nationalIdentifier,
    birthdate,
    shouldBeCopyable = true,
    isInvalid = false,
    isPending = false,
    shouldBeHidden = false,
    newNationalIdentifier,
    previousNationalIdentifier,
    className,
}: AddNationalIdentifierFieldPropertyObjectProps) => {
    if (!nationalIdentifier || shouldBeHidden) return null;

    const formattedNationalIdentifier =
        formatNationalIdentityNumber(nationalIdentifier);
    const view = (
        <NationalIdentifierView
            nationalIdentifier={nationalIdentifier}
            birthdate={birthdate}
            isInvalid={isInvalid}
            isPending={isPending}
            newNationalIdentifier={newNationalIdentifier}
            previousNationalIdentifier={previousNationalIdentifier}
            className={cn('font-bold', className)}
        />
    );

    return {
        label: formatNationalIdentifierText(R.NationalIdentifier),
        value: shouldBeCopyable ? (
            <CopyableField
                fieldType="nationalIdentifier"
                displayValue={view}
                copyValue={formattedNationalIdentifier}
            />
        ) : (
            view
        ),
        type: PropertyType.CUSTOM,
    };
};
